// extracted by mini-css-extract-plugin
export default {"chat_modal":"PjteEefVSLRlg3qfA95w","privacy_btn":"WkaI6gxfdxDYat032M_l","contact-form":"X4O8pK22egORbuC0FyJQ"};